import Vue from 'vue'
import Router from 'vue-router'


import index from '@/view/index/index'
import enterprise from '@/view/enterprise/enterprise'
import service from '@/view/service/service'
import cases from '@/view/case/case'
import servingCustomers from '@/view/servingcustomers/servingcustomers'
import honor from '@/view/honor/honor'
import recruit from '@/view/recruit/recruit'
import culture from '@/view/culture/culture'

import administration from '@/view/administration/administration'
import contactus from '@/view/contact_us/contact_us'
import course from '@/view/course/course'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/enterprise',
      name: 'enterprise',
      component: enterprise,
      meta: {
        title: '公司简介'
      }
    },
    {
      path: '/service',
      name: 'service',
      component: service,
      meta: {
        title: '服务内容'
      }
    },
    {
      path: '/cases',
      name: 'cases',
      component: cases,
      meta: {
        title: '服务案例'
      }
    }, {
      path: '/servingCustomers',
      name: 'servingCustomers',
      component: servingCustomers,
      meta: {
        title: '服务客户'
      }
    }, {
      path: '/honor',
      name: 'honor',
      component: honor,
      meta: {
        title: '企业荣誉'
      }
    }, {
      path: '/recruit',
      name: 'recruit',
      component: recruit,
      meta: {
        title: '企业招聘'
      }
    }, {
      path: '/culture',
      name: 'culture',
      component: culture,
      meta: {
        title: '企业文化'
      }
    }, {
      path: '/administration',
      name: 'administration',
      component: administration,
      meta: {
        title: '公司管理层'
      }
    }, {
      path: '/contactus',
      name: 'contactus',
      component: contactus,
      meta: {
        title: '联系我们'
      }
    }, {
      path: '/course',
      name: 'course',
      component: course,
      meta: {
        title: '企业历程'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js